module.exports = __webpack_public_path__ + "images/help-videos-preview-kanban-0b21fc39a4f29b8cf883b34f22839363.png";